export const RolesService = {
  getData() {
    return [
      {
        id: 1,
        roleName: 'Роль 1',
        displayedName: 'Роль 1',
        description: 'Описание 1'
      },
      {
        id: 2,
        roleName: 'Роль 2',
        displayedName: 'Роль 2',
        description: 'Описание 2'
      },
      {
        id: 3,
        roleName: 'Роль 3',
        displayedName: 'Роль 3',
        description: 'Описание 3'
      },
      {
        id: 4,
        roleName: 'Роль 4',
        displayedName: 'Роль 4',
        description: 'Описание 4'
      },
      {
        id: 5,
        roleName: 'Роль 5',
        displayedName: 'Роль 5',
        description: 'Описание 5'
      },
      {
        id: 6,
        roleName: 'Роль 6',
        displayedName: 'Роль 6',
        description: 'Описание 6'
      },
      {
        id: 7,
        roleName: 'Роль 7',
        displayedName: 'Роль 7',
        description: 'Описание 7'
      },
      {
        id: 8,
        roleName: 'Роль 8',
        displayedName: 'Роль 8',
        description: 'Описание 8'
      },
      {
        id: 9,
        roleName: 'Роль 9',
        displayedName: 'Роль 9',
        description: 'Описание 9'
      },
      {
        id: 10,
        roleName: 'Роль 10',
        displayedName: 'Роль 10',
        description: 'Описание 10'
      },
      {
        id: 11,
        roleName: 'Роль 11',
        displayedName: 'Роль 11',
        description: 'Описание 11'
      },
      {
        id: 12,
        roleName: 'Роль 12',
        displayedName: 'Роль 12',
        description: 'Описание 12'
      },
      {
        id: 13,
        roleName: 'Роль 13',
        displayedName: 'Роль 13',
        description: 'Описание 13'
      },
      {
        id: 14,
        roleName: 'Роль 14',
        displayedName: 'Роль 14',
        description: 'Описание 14'
      },
      {
        id: 15,
        roleName: 'Роль 15',
        displayedName: 'Роль 15',
        description: 'Описание 15'
      },
      {
        id: 16,
        roleName: 'Роль 16',
        displayedName: 'Роль 16',
        description: 'Описание 16'
      },
      {
        id: 17,
        roleName: 'Роль 17',
        displayedName: 'Роль 17',
        description: 'Описание 17'
      },
      {
        id: 18,
        roleName: 'Роль 18',
        displayedName: 'Роль 18',
        description: 'Описание 18'
      },
      {
        id: 19,
        roleName: 'Роль 19',
        displayedName: 'Роль 19',
        description: 'Описание 19'
      },
      {
        id: 20,
        roleName: 'Роль 20',
        displayedName: 'Роль 20',
        description: 'Описание 20'
      },
      {
        id: 21,
        roleName: 'Роль 21',
        displayedName: 'Роль 21',
        description: 'Описание 21'
      },
      {
        id: 22,
        roleName: 'Роль 22',
        displayedName: 'Роль 22',
        description: 'Описание 22'
      },
      {
        id: 23,
        roleName: 'Роль 23',
        displayedName: 'Роль 23',
        description: 'Описание 23'
      },
      {
        id: 24,
        roleName: 'Роль 24',
        displayedName: 'Роль 24',
        description: 'Описание 24'
      },
      {
        id: 25,
        roleName: 'Роль 25',
        displayedName: 'Роль 25',
        description: 'Описание 25'
      }
    ];
  },

  getRoles() {
    return Promise.resolve(this.getData());
  }
};
